import Column from 'components/Column'
import I18n from 'components/I18n'
import { OverlayLoader } from 'components/Loaders'
import TabMenuNew from 'components/TabMenuNew/TabMenuNew'
import TabMenuNewItem from 'components/TabMenuNew/TabMenuNewItem'
import Text from 'components/Text'
import formName from 'constants/formName'
import { actions, selectors } from 'data'
import { WhitelistAddressFormType } from 'data/Form/WhitelistAddress/types'
import messages from 'lang'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { InjectedFormProps, reduxForm } from 'redux-form'
import styled from 'styled-components'
import { color, screenWidth } from 'utils'

import preventUserInputCss from '../PreventUserInput'
import { PropsType as ContainerPropsType } from '.'
import AddAddress from './AddAddress'
import Disable from './Disable'
import ListAddresses from './ListAddresses'
import Setup from './Setup'

const stepComponent = {
  addaddress: AddAddress,
  disable: Disable,
  listaddresses: ListAddresses,
  setup: Setup
}

type NotFormProps = ContainerPropsType
export type PropsType = NotFormProps & InjectedFormProps<WhitelistAddressFormType, NotFormProps>

const Form = styled.form`
  ${preventUserInputCss};
  box-sizing: border-box;
  width: 100%;
  background: ${color('dark800')};

  @media all and (min-width: ${screenWidth('sm')}) {
    min-width: 540px;
  }
`
const CustomTabMenu = styled(TabMenuNew)`
  margin: 0 2rem;
`
const TitleWrapper = styled(Column)`
  position: relative;
  width: 100%;
`
const Title = styled(Text)`
  display: flex;
  align-items: center;
  margin: 2rem 0;
  text-align: center;
`

const Whitelist = (props: PropsType) => {
  const { goToStep, handleSubmit, isLoading, isWhitelistingEnabled, step } = props
  const Step = stepComponent[step]

  const dispatch = useDispatch()
  const twoFactorStatus = useSelector(selectors.auth.getTwoFactorStatus)
  const has2FASetup = twoFactorStatus && twoFactorStatus.length > 0
  const needsChallenge = has2FASetup && twoFactorStatus!.includes('WALLET_SMS')

  React.useEffect(() => {
    dispatch(actions.twoFactor.getStatus())
  }, [])

  React.useEffect(() => {
    if (needsChallenge) {
      dispatch(actions.auth.secondFactorChallenge.createChallenge())
    }
  }, [needsChallenge])

  return (
    <Form isLoading={isLoading} onSubmit={handleSubmit}>
      {step !== 'setup' && (
        <>
          <TitleWrapper alignItems='center' justifyContent='center' shrink={0}>
            <Title color='white' size='xl' weight={600}>
              <I18n data={messages.whitelisted_addresses} />
            </Title>
          </TitleWrapper>
          <CustomTabMenu>
            <TabMenuNewItem
              data-e2e='addNewTab'
              onClick={() => goToStep('addaddress')}
              selected={step === 'addaddress'}
              width='33%'
            >
              <I18n data={messages.whitelisting_menu_add} />
            </TabMenuNewItem>
            <TabMenuNewItem
              data-e2e='manageTab'
              onClick={() => goToStep('listaddresses')}
              selected={step === 'listaddresses'}
              width='33%'
            >
              <I18n data={messages.whitelisting_menu_manage} />
            </TabMenuNewItem>
            <TabMenuNewItem
              data-e2e='disableTab'
              disabled={!isWhitelistingEnabled}
              onClick={() => {
                if (!isWhitelistingEnabled) return
                goToStep('disable')
              }}
              selected={step === 'disable'}
              width='33%'
            >
              <I18n data={messages.whitelisting_menu_disable} />
            </TabMenuNewItem>
          </CustomTabMenu>
        </>
      )}

      <Step {...props} />

      {props.isLoading && <OverlayLoader />}
    </Form>
  )
}

const formWrapper = reduxForm<WhitelistAddressFormType, NotFormProps>({
  form: formName.WHITELIST_ADDRESS,
  initialValues: { currency: 'BTC' }
})

export default formWrapper(Whitelist)
